import { TeamsDisplay, OneLineTeamsDisplay, SimpleTeamsWidget } from "./simple.teams.display";
import { DataPlugin, DisplayData, DisplayDataWidget } from "../../data";

// Use a constant that represents the Teams message data type
export const TeamsDataName = "teamsMessage";

// Define the TeamsData type based on the sample JSON structure
export type TeamsData = {
    type: "teamsMessage";
    source: string;
    hitId: string;
    rank: number;
    summary: string;
    resource: {
        id: string;
        body: {
            contentType: string;
            content: string;
        };
        from: {
            user: {
                id: string;
                displayName: string;
                userPrincipalName: string;
            };
        };
        createdDateTime: string;
        lastModifiedDateTime: string;
    };
};

// Create a data plugin for Teams messages that uses the appropriate display components
export function TeamsDataPlugin(
    DisplayData: DisplayData<TeamsData> = TeamsDisplay,
    DisplayDataOneLine: DisplayData<TeamsData> = OneLineTeamsDisplay,
    DisplayDataWidget: DisplayDataWidget<TeamsData> = SimpleTeamsWidget
): DataPlugin<TeamsData> {
    return {
        plugin: "data",
        name: TeamsDataName,
        DisplayData,
        DisplayDataOneLine,
        DisplayDataWidget,
        idFrom: data => `${data.type}.${data.hitId}`,
    };
}
